<template>
  <div>
    <div class="mainbody">
      <!--<code>{{ products }}</code>-->
      <!--quickModal START-->
      <div id="quickModal" class="modal quickModal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <div class="row">
                <div class="col-md-5">
                  <div class="breadcum mb15">
                    <i class="fa fa-circle-o" aria-hidden="true"></i> {{get_category_name}}
                    <i class="fa fa-angle-double-right" aria-hidden="true"></i> {{modalProductData.name}}
                  </div>
                  <div class="right-border img-max-height">
                    <img v-if="changeModalGallery_image===modalProductData.featured_image"
                         v-bind:src="fileUrl+'uploads/products/'+modalProductData.featured_image"
                         class="img-responsive">
                    <img v-else v-bind:src="fileUrl+'uploads/products/'+changeModalGallery_image"
                         class="img-responsive">
                  </div>
                </div>
                <div class="col-md-7">
                  <h3 class="m-p-title" v-if="globalLanguage=='EN'">{{modalProductData.name}}</h3>
                  <h3 class="m-p-title" v-else>{{modalProductData.name_bn}}</h3>
                  <!--<div class="rating">-->
                  <!--&lt;!&ndash;<i class="fa fa-star"></i> <i class="fa fa-star"></i> <i class="fa fa-star"></i> <i&ndash;&gt;-->
                  <!--&lt;!&ndash;class="fa fa-star"></i> <i class="fa fa-star"></i>&ndash;&gt;-->
                  <!--<span> </span>-->
                  <!--</div>-->
                  <div class="code"> Code: <b>#{{modalProductData.id}}</b></div>
                  <div class="code">Availability:
                    <span class="green-color" v-if="modalProductData.stock_quantity>0">In Stock</span>
                    <span class="red-color" v-else>Out of Stock</span>
                  </div>
                  <div class="code mt10" v-if="modalProductData.dosages_description"> Type: {{modalProductData.dosages_description}} </div>
                  <div class="code" v-if="modalProductData.strength"> Strength: {{modalProductData.strength}}</div>
                  <div class="code  " v-if="modalProductData.generic_name"> Generic Name: {{modalProductData.generic_name}}  </div>

                  <div class="price mt5">
                    <h3 class="running base-color">{{ modalProductData.price-modalProductData.discount }} &#8364;</h3>
                    <span class="discounted"
                          v-if="modalProductData.discount>0"><span>{{ modalProductData.price }} &#8364;</span> </span>
                    <!--{{//Math.round(modalProductData.discount) }}% Off -->
                  </div>
                  <div class="quantity mt15 clearfix">
                    <div>Quantity</div>
                    <div class="pull-left">
                      <span variant="info" @click="decrement(modalProductData.id)"><img src="@/assets/images/minus-yellow.png" width="24px"/></span>
                    </div>
                    <input class="pull-left text-center" type="text" min="1" :value="quantity" readonly>
                    <div class="pull-left">
                    <span variant="info" @click="increment(modalProductData.id)"><img src="@/assets/images/plusorange.png"
                                                                                      width="24px"/></span>
                    </div>
                  </div>
                  <button type="button" class="btn btn-add-to-cart btn-sm mt30" v-if="modalProductData.stock_quantity>0 && globalLanguage=='EN'" @click="createCartsModal()">Add to
                    Cart
                  </button>
                  <button type="button" class="btn  btn-add-to-cart bn btn-sm mt30" v-if="modalProductData.stock_quantity>0 && globalLanguage!='EN'" @click="createCartsModal()">
                    ব্যাগে যোগ করুন
                  </button>
                </div>
                <div class="col-md-12 pd0" >
                  <div v-if="modalProductData.gp_image_1">
                    <hr>
                    <div  class="ml15 pull-left  ">
                      <div  class="gallery-img" v-if="modalProductData.gp_image_1" @click="galleryImg(modalProductData.gp_image_1)">
                        <img v-bind:src="fileUrl+'uploads/products/'+modalProductData.gp_image_1" class="img-responsive">
                      </div>
                      <div  class="gallery-img" v-if="modalProductData.gp_image_2" @click="galleryImg(modalProductData.gp_image_2)">
                        <img v-bind:src="fileUrl+'uploads/products/'+modalProductData.gp_image_2" class="img-responsive">
                      </div>
                      <div  class="gallery-img" v-if="modalProductData.gp_image_3" @click="galleryImg(modalProductData.gp_image_3)">
                        <img v-bind:src="fileUrl+'uploads/products/'+modalProductData.gp_image_3" class="img-responsive">
                      </div>
                      <div  class="gallery-img" v-if="modalProductData.gp_image_4" @click="galleryImg(modalProductData.gp_image_4)">
                        <img v-bind:src="fileUrl+'uploads/products/'+modalProductData.gp_image_4" class="img-responsive">
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <ul class="nav nav-tabs m-tab-menu mt0" v-if="modalProductData.description">
                    <!--                  <li ><a data-toggle="tab" href="#Description">Reviews</a></li>-->
                    <li class="active"><a data-toggle="tab" href="#Reviews">Description</a></li>
                  </ul>
                  <div class="tab-content ml15">
                    <div id="Description" class="tab-pane ">
                    </div>
                    <div id="Reviews" class="tab-pane fade in active" style="padding-right: 15px;">
                      <br>
                      <div v-html="modalProductData.description"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!--quickModal END-->

      <div class=" products-list">
        <div class="col-lg-12 col " v-if="category_image!=''">
          <img v-bind:src="fileUrl+'uploads/cat_images/'+category_image" class="img-responsive">
        </div>
        <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12 col" v-for="(product, index) in products">
          <div class="product">
            <div class="discount-ribbon" v-if="product.discount>0">{{product.discount}} &#8364; <i> OFF</i></div>
            <div class="img-fix-area">
              <img v-bind:src="fileUrl+'uploads/products/'+product.featured_image" :alt="product.name"  class="img-responsive"/>
              <div class="overlay-info">
                <button type="button" @click="quickView(index)" data-toggle="modal" data-target="#quickModal"
                        class="btn btn-sm  btn-quick animated fadeIn ">Quick view
                </button>
              </div>
            </div>
            <div class="summary">
              <h3 class="name" v-if="globalLanguage=='EN'">{{product.name}}</h3>
              <h3 class="name bn" v-else>{{product.name_bn}}</h3>
              <div class="weight">{{product.unit_quantity}} {{product.unit}}</div>
              <div class="price">
                <span class="running">{{ product.price-product.discount }} &#8364;</span>
                <!--<span class="running" > {{ product.price }} &#8364;</span>-->
                <div >
                  <span class="discounted" v-if="product.discount>0">{{ product.price }} &#8364;</span>
                  <span v-else>&nbsp;</span>
                </div>
              </div>
              <ProductCartControl
                v-if="product.stock_quantity>0"
                id-prefix=""
                :product-id="product.id"
                :language="globalLanguage"
                :quantity="getCartQuantity(product.id)"
                :in-cart="product.created_at=='marked' || hasCartQuantity(product.id)"
                :add-label="globalLanguage=='EN' ? 'Add To BAG' : 'ব্যাগে যোগ করুন'"
                @add="createCarts(index,product.id)"
                @decrement="cartDecrement(product.id)"
                @increment="cartIncrement(product.id)"
              />
              <div  class="button-label" v-else>
                <div class="btn-group d-block newBtn">
                  <button type="button"   class="btn btn-sm btn-block add-to-cart-btn">Out of Stock</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
            <CartData
        :carts="carts"
        :sum-cart-total="sum_cart_total || 0"
        :file-url="fileUrl"
        :global-language="globalLanguage"
        @remove-cart-item="removeCartItem"
        @cart-increment="cartIncrement"
        @cart-decrement="cartDecrement"
      />
    </div>
    <div class="mobilemenu">
      <div class="same">
        <router-link to="/" class="icon-bottom">
          <img
            src="@/assets/images/icons/home-ash.png" width="31px">
        </router-link >
      </div>
      <div class="gocheckout" v-if="carts.length>0">
        <router-link to="/checkout">
          GO CHECKOUT
        </router-link>
      </div>
      <div class="gocheckout start" @click="toogleNav()" v-else>
        <span>
          START SHOPPING
        </span>
      </div>
      <div class="mybag same carts">
                <span>
                     <span class="badge">0</span>
                 <img class="iconbag" src="@/assets/images/icons/bag.png" alt="Shopping-bag" height="31px">

               </span>
      </div>
    </div>
  </div>
</template>
<script>
const $ = require('jquery');
window.$ = $;
$(function () {
  $(window)
    .scroll(function () {
      $('nav')
        .toggleClass('scrolled', $(this)
          .scrollTop() > 20);
    });
});
import axios from 'axios';
import CartData from "./CartData";
import ProductCartControl from "./ProductCartControl";
export default {
  components: { CartData, ProductCartControl },
  data() {
    return {
      products: [],
      menuStatus: true,
      modalProductData: [],
      recentViews: [],
      get_category_name: '',
      get_sub_category_name: '',
      get_child_category_name: '',
      loadMore: true,
      quantity: 1,
      images: [],
      changeModalGallery_image: '',
      categories: [],
      category_image:'',
      sub_categories: [],
      child_sub_categories: [],
      //carts  rlated  variables
      token: '',
      getcarts: [],
      carts: [],
      isOpen: true,
      sum_cart_total: '',
      parseCartData: [],
      activeItem: '',
      mainCategories: [],
      subCategories: [],
      language:'',
      childCategories: []
    };
  },
  created: function () {
    //this.allCategory();
    //this.checkingCartProducts();
    this.language=this.globalLanguage;
  },
  mounted() {

    let vm = this;
    if (localStorage.getItem("token")) {
      let vm = this;
      vm.token = localStorage.getItem("token");
    }
    if (localStorage.getItem("carts")) {
      vm.carts = JSON.parse(localStorage.getItem("carts"));
    } else {
      vm.carts = [];
    }
    this.calculateCartTotal();
    this.category_products();
  },
  watch: {
    '$route'() {
      this.category_products();
    }
  },
  methods: {
    hasCartQuantity(productId) {
      const cart = this.carts.find(item => item.product_id == productId);
      return Boolean(cart && Number(cart.cart_quantity) > 0);
    },
    getCartQuantity(productId) {
      const cart = this.carts.find(item => item.product_id == productId);
      return cart ? cart.cart_quantity : 0;
    },
    toogleNav: function () {
      $(".small-device #sidebar-area")
        .toggleClass('show');
      $("#content-area")
        .toggleClass('fullwidth');
      $("#sidebar-area")
        .toggleClass('hidden-sidebar');
      if (this.menuStatus == true) {
        this.menuStatus = false;
      } else if (this.menuStatus == false) {
        this.menuStatus = true;
      }
    },
    isActive: function (menuItem) {
      return this.activeItem === menuItem;
    },
    setActive: function (menuItem) {
      this.activeItem = menuItem; // no need for Vue.set()
    },
    increment(product_id) {
      //this.quantity++
      let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
      if (objIndex != -1){
        let oldQuantity = this.carts[objIndex].cart_quantity;
        let stock_quantity = this.carts[objIndex].stock_quantity;
        if(this.quantity<stock_quantity){
          let newQuantity = oldQuantity + 1;
          let price = this.carts[objIndex].price;
          this.carts[objIndex].cart_quantity = newQuantity;
          this.carts[objIndex].subtotal = price * newQuantity;
          localStorage.setItem("carts", JSON.stringify(this.carts));
          this.carts = JSON.parse(localStorage.getItem("carts"));
          $('#' + product_id + " .amountQuantity")
            .text(newQuantity);
          this.calculateCartTotal();
          this.quantity=newQuantity;
        }
      }else{
        let objIndex = this.products.findIndex((obj => obj.id == product_id));
        let stock_quantity = Math.trunc(this.products[objIndex].stock_quantity);
        if(this.quantity<stock_quantity){
          this.quantity++
        }else{
          this.quantity
        }
      }
    },
    decrement(product_id) {

      if (this.quantity === 1) {
      } else {
        this.quantity--;
        let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
        if (objIndex != -1){
          let oldQuantity = this.carts[objIndex].cart_quantity;
          if (oldQuantity > 1) {
            let newQuantity = oldQuantity - 1;
            let price = this.carts[objIndex].price;
            this.carts[objIndex].cart_quantity = newQuantity;
            this.carts[objIndex].subtotal = price * newQuantity;
            localStorage.setItem("carts", JSON.stringify(this.carts));
            this.carts = JSON.parse(localStorage.getItem("carts"));
            this.calculateCartTotal();
            $("#"+product_id +" .amountQuantity").text(newQuantity);
          }
        }
      }
    },
    category_products: function () {
      let vm = this;
      let restaurant_slug = this.$route.params.id;
      axios.get(this.globalUrl + "restaurant/"+restaurant_slug)
        .then(function (response) {
          console.log(response);
          vm.products = response.data.foods;
          $(".button-label").removeClass('cartAdded');
        }).catch((response) => {

        vm.$toasted.show('Something wrong  Refresh  again.', {
          type: 'error',
          icon: 'fa-exclamation-triangle'
        });
      });
    },
    quickView: function (index) {

      let vm = this;
      vm.modalProductData = this.products[index];
      //this  is  used  for  just chnage  folder  for  gallery  image and  featured  image in  moddal
      vm.changeModalGallery_image = this.products[index].featured_image;
      let  productID=vm.modalProductData.id;
      //console.log(productID);
      const result = this.carts.find(function(obj) {
        return obj.product_id == productID;
      });

      if (result===undefined){
        vm.quantity=1;
      }else {
        let oldQuantity = result.cart_quantity;
        vm.quantity=oldQuantity;
      }

    },
    //carts  related  functions
    cartIncrement(product_id) {
      //alert(product_id);
      let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
      let oldQuantity = this.carts[objIndex].cart_quantity;
      let stock_quantity = this.carts[objIndex].stock_quantity;
      if(oldQuantity<stock_quantity){
        let newQuantity = oldQuantity + 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        $('#'+product_id+ " .amountQuantity").text(newQuantity);
        this.calculateCartTotal();
        $("#"+product_id).addClass("animated");
        setTimeout(function(){
          $("#"+product_id).removeClass("animated");
        }, 500);
      }
    },
    cartDecrement(product_id) {
      let objIndex = this.carts.findIndex((obj => obj.product_id == product_id));
      let oldQuantity = this.carts[objIndex].cart_quantity;
      if (oldQuantity > 1) {
        let newQuantity = oldQuantity - 1;
        let price = this.carts[objIndex].price;
        this.carts[objIndex].cart_quantity = newQuantity;
        this.carts[objIndex].subtotal = price * newQuantity;
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        $("#"+product_id +" .amountQuantity").text(newQuantity);
        $("#"+product_id).addClass("animated");
        setTimeout(function(){
          $("#"+product_id).removeClass("animated");
        }, 500);
      }else if (oldQuantity == 1) {
        this.carts = this.carts.filter((e) => e.product_id !== product_id);
        $("#"+product_id).removeClass('cartAdded');
        localStorage.setItem("carts", JSON.stringify(this.carts));
        this.calculateCartTotal();
      }

    },
    removeCartItem: function (product_id) {
      //alert(product_id);
      this.carts = this.carts.filter((e) => e.product_id !== product_id);
      $("#"+product_id).removeClass('cartAdded');
      localStorage.setItem("carts", JSON.stringify(this.carts));
      this.calculateCartTotal();
    },
    createCarts: function (index,product_id) {
      let vm = this;
      let thisProductID=product_id;
      $("#"+product_id +" .amountQuantity").text(1);
      //alert(thisProductID);
      //check  array  index  product  info
      //console.log(this.products[index]);
      let check_if_cart_item_exist = this.carts.findIndex(x => x.product_id === this.products[index].id);

      if (check_if_cart_item_exist >= 0) {
        $("#"+thisProductID).addClass('cartAdded');
        let objIndex =this.carts.findIndex(x => x.product_id === this.products[index].id);
        let oldQuantity = this.carts[objIndex].cart_quantity;
        $('#'+thisProductID+ " .amountQuantity").text(oldQuantity);

      } else {
        $("#"+thisProductID).addClass('cartAdded');

        //console.log(this.products[index].id);
        let result = JSON.parse(localStorage.getItem("carts"));
        if (result == null)
          result = [];
        let price = (this.products[index].price - this.products[index].discount);
        //console.log(price);
        result.unshift({
          'product_id': this.products[index].id,
          'product_name': this.products[index].name,
          'product_name_bn': this.products[index].name_bn,
          'product_image': this.products[index].featured_image,
          'price': price,
          'image': this.products[index].featured_image,
          'quantity': this.products[index].unit_quantity,
          'unit': this.products[index].unit,
          'cart_quantity': 1,
          'stock_quantity': this.products[index].stock_quantity,
          'subtotal': price * 1
        });
        // save the new result array
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        vm.$toasted.show('New Product Added In your Bag.', {
          type: 'success',
          icon: 'fa-check-circle',
          position: "bottom-left"
        });
        $(".carts")
          .addClass("animated zoomIn");
        $(".cart_amount")
          .addClass("shadow-pulse");
        setTimeout(function () {
          $(".carts")
            .removeClass("animated zoomIn");
          $(".cart_amount")
            .removeClass("shadow-pulse");
        }, 5000);
      }

    },
    createCartsModal: function () {
      let vm = this;
      let this_product_quantity = vm.quantity;
      let singleProduct = vm.modalProductData;
      // alert(singleProduct.id);
      let check_if_cart_item_exist = this.carts.findIndex(x => x.product_id === singleProduct.id);
      if (check_if_cart_item_exist >= 0) {
        vm.$toasted.show('Already Added In your Bag.', {
          type: 'error',
          icon: 'fa-exclamation-triangle',
          position: "bottom-left"
        });
      } else {
        let result = JSON.parse(localStorage.getItem("carts"));
        if (result == null)
          result = [];
        let price = (singleProduct.price - singleProduct.discount);
        if(this_product_quantity<=singleProduct.stock_quantity){
          this_product_quantity=this_product_quantity;
        }else{
          this_product_quantity=Math.trunc(singleProduct.stock_quantity);
        }
        result.unshift({
          'product_id': singleProduct.id,
          'product_name': singleProduct.name,
          'product_name_bn': singleProduct.name_bn,
          'product_image': singleProduct.featured_image,
          'price': price,
          'image': singleProduct.featured_image,
          'cart_quantity': this_product_quantity,
          'quantity': singleProduct.unit_quantity,
          'unit': singleProduct.unit,
          'stock_quantity': singleProduct.stock_quantity,
          'subtotal': price * this_product_quantity
        });
        // save the new result array
        localStorage.setItem("carts", JSON.stringify(result));
        vm.carts = JSON.parse(localStorage.getItem("carts"));
        this.calculateCartTotal();
        vm.$toasted.show('New Product Added In your Bag.', {
          type: 'success',
          icon: 'fa-check-circle',
          position: "bottom-left"
        });
      }

    },
    calculateCartTotal() {
      let vm = this;
      for (var i = 0, sum = 0; i < vm.carts.length; sum += vm.carts[i++].subtotal) ;
      vm.sum_cart_total = sum;
      for (var i = 0, totalSum = 0; i < vm.carts.length; totalSum += vm.carts[i++].cart_quantity) ;
      vm.cartsCountProduct = totalSum;
      localStorage.setItem("cartsCountProduct", totalSum);
      $(".carts .badge").text(vm.carts.length);
    },
    galleryImg: function (image_url) {
      let vm = this;
      vm.changeModalGallery_image =image_url;
    }
  }
};
</script>
